(function () {
  if (customElements.get('goes-card')) return;

  class GoesCard extends HTMLElement {
    connectedCallback() {
      this.idInput = this.querySelector('[data-goes-id]');
      this.priceEl = this.querySelector('[data-goes-price]');
      this.compareEl = this.querySelector('[data-goes-compare]');
      this.addEventListener('change', this.onChange.bind(this));
    }

    onChange(e) {
      if (!e.target.matches('[data-goes-variant]')) return;
      var input = e.target;
      if (this.idInput) this.idInput.value = input.value;
      if (this.priceEl) this.priceEl.textContent = input.getAttribute('data-price') || this.priceEl.textContent;
      if (this.compareEl) {
        var cmp = input.getAttribute('data-compare');
        if (cmp) { this.compareEl.textContent = cmp; this.compareEl.style.display = ''; }
        else { this.compareEl.style.display = 'none'; }
      }
    }
  }

  customElements.define('goes-card', GoesCard);
})();
